import { RedmineStatus } from '@/constants/TrainingPlanning';

export const getRedmineStatus = (status: string) => {
	switch (status) {
		case 'Solicitação Aprovada':
			return 'Aprovado';
		case 'Solicitação em Análise':
			return 'Pendente';
		case 'Solicitação Reprovada':
			return 'Negada';
		default:
			return '';
	}
};

export const getRedmineStatusColor = (status: string) => {
	switch (status) {
		case 'Solicitação Aprovada':
			return '#10AE88';
		case 'Solicitação em Análise':
			return '#FFA654';
		case 'Solicitação Reprovada':
			return '#F4503A';
		default:
			return '#454343';
	}
};

export const getRedmineStatusUpperCase = (status: string) => {
	switch (status) {
		case RedmineStatus.SolicitacaoAprovada:
			return 'APROVADA';
		case RedmineStatus.SolicitacaoCancelada:
			return 'CANCELADA';
		case RedmineStatus.SolicitacaoRejeitada:
			return 'REJEITADA';
		case RedmineStatus.SolicitacaoEmAnalise:
			return 'PENDENTE';
		case RedmineStatus.SolicitacaoExpirada:
			return 'EXPIRADA';
		case RedmineStatus.EmProcessamento:
			return 'EM PROCESSAMENTO';
		case RedmineStatus.FalhaNoProcessamento:
			return 'FALHA NO PROCESSAMENTO';
		case RedmineStatus.ErroNaAtribuicao:
			return 'ERRO NA ATRIBUIÇÃO';
		default:
			return '-';
	}
};

export const getRedmineStatusColorUpperCase = (status: string) => {
	switch (status) {
		case RedmineStatus.SolicitacaoAprovada:
			return '#10AE88';
		case RedmineStatus.SolicitacaoRejeitada:
			return '#F4503A';
		case RedmineStatus.SolicitacaoCancelada:
			return '#F4503A';
		case RedmineStatus.SolicitacaoExpirada:
			return '#FFC000';
		case RedmineStatus.FalhaNoProcessamento:
			return '#F4503A';
		case RedmineStatus.ErroNaAtribuicao:
			return '#F4503A';
		default:
			return '#454343';
	}
};
